import React from 'react';
import {Row, Col, Button, Upload, Icon} from 'antd';
import FieldBlock from '../../../field-block';
import DividerBlock from "../../../divider-block";
import {getWithTranslate} from "../../../../helpers/doc_type.helper";
import i18n from '../../../../i18n';

export default function EditBelarusLegalEntityDocs({legalEntityData, docFields, setDocFields, fieldsErrors}) {
  const legalEntityDataAliases = getWithTranslate('legalEntityDataAliases');
  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  const getUploaderClass = (name, multiple = true) => {
    const hasFiles = name in docFields;
    if (!hasFiles) {
      return null;
    }
    return {
      multiple: multiple,
      showUploadList: true,
      onRemove: (file) => {
        setDocFields({...docFields, [name]: null});
      },
      beforeUpload: (file, fileList) => {
        if (multiple) {
          if (docFields[name]) {
            setDocFields({...docFields, [name]: docFields[name].concat(fileList)});
          } else {
            setDocFields({...docFields, [name]: fileList});
          }
        } else {
          setDocFields({...docFields, [name]: file});
        }
        return false;
      },
      fileList: docFields[name],
      listType: 'picture',
    };
  };

  return (
    <Row gutter={20}>
      <DividerBlock label={i18n.t('modals.modalEditLegalEntityDocs.divider.docs')}/>
      {legalEntityData.OrgFormId !== 16 && (
        <>
          { 'articlesOfAssociation' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="articlesOfAssociation" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.articlesOfAssociation} fileList={docFields.articlesOfAssociation}
                      className="single-btn-upload" {...getUploaderClass('articlesOfAssociation', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.articlesOfAssociation}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
          )}
          {'documentsConfirmingOwnershipOfOfficePremises' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="documentsConfirmingOwnershipOfOfficePremises" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.documentsConfirmingOwnershipOfOfficePremises}
                      fileList={docFields.documentsConfirmingOwnershipOfOfficePremises}
                      className="single-btn-upload" {...getUploaderClass('documentsConfirmingOwnershipOfOfficePremises', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.documentsConfirmingOwnershipOfOfficePremisesBel}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
              )}
          { 'copyOfBankCard' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="copyOfBankCard" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.copyOfBankCard} fileList={docFields.copyOfBankCard}
                      className="single-btn-upload" {...getUploaderClass('copyOfBankCard', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.copyOfBankCardBel}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
              )}
        </>
      )}
      { 'certificateOfStateRegistration' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="certificateOfStateRegistration" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.certificateOfStateRegistration}
                  fileList={docFields.certificateOfStateRegistration}
                  className="single-btn-upload" {...getUploaderClass('certificateOfStateRegistration', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfStateRegistrationBel}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
          )}
      { 'passport' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="passport" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.passport} fileList={docFields.passport}
                  className="single-btn-upload" {...getUploaderClass('passport', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.passportBel}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
      )}
      { 'specialPermitForTheRightToCarryOutActivities' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="specialPermitForTheRightToCarryOutActivities" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.specialPermitForTheRightToCarryOutActivities}
                  fileList={docFields.specialPermitForTheRightToCarryOutActivities}
                  className="single-btn-upload" {...getUploaderClass('specialPermitForTheRightToCarryOutActivities', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.specialPermitForTheRightToCarryOutActivities}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
          )}
      { 'partnerCard' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="partnerCard" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.partnerCard} fileList={docFields.partnerCard}
                  className="single-btn-upload" {...getUploaderClass('partnerCard', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.partnerCardKz}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
          )}
      { 'residenceCertificate' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="residenceCertificate" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.residenceCertificate} fileList={docFields.residenceCertificate}
                  className="single-btn-upload" {...getUploaderClass('residenceCertificate', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.residenceCertificateBel}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
          )}
    </Row>
  );
}
